import { ComponentPropsWithoutRef, forwardRef, useEffect } from 'react';

import { Text } from '@spotify-internal/encore-web';

import { useOptionalSectionContext } from './SectionContext';

export type SectionTitleProps = Omit<
  ComponentPropsWithoutRef<'h5'>,
  'children'
> & {
  children: string;
};

const SectionTitle = forwardRef<HTMLHeadingElement, SectionTitleProps>(
  (props, ref) => {
    const { className, children, ...rest } = props;
    const registerSectionMetadata =
      useOptionalSectionContext()?.registerSectionMetadata;

    useEffect(() => {
      if (!registerSectionMetadata) return undefined;

      const title = children.trim();
      if (!title) return undefined;

      return registerSectionMetadata({ title });
    }, [children, registerSectionMetadata]);

    return (
      <Text
        as="h5"
        variant="titleExtraSmall"
        ref={ref}
        className={className}
        {...rest}
      >
        {children}
      </Text>
    );
  },
);

SectionTitle.displayName = 'Section.Title';

export default SectionTitle;
